module.exports = __webpack_public_path__ + "static/media/sri-maha.f32d37f0.jpeg";